export const ACCOUNT_TYPE = {
  Personal: 'Personal',
  Business: 'Business',
} as const;

export type AccountType = (typeof ACCOUNT_TYPE)[keyof typeof ACCOUNT_TYPE];
